import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import PropTypes from "prop-types";

const selectedWarehouses = [5, 6, 7, 12];

class SoldByWarehouse extends Component {

    render() {

        const { warehouses, soldByWarehouse, soldByWarehouseAdjusted } = this.props;

        return (
            <Table celled>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Warehouse</Table.HeaderCell>
                        <Table.HeaderCell>Sold Adjusted</Table.HeaderCell>
                        <Table.HeaderCell>Sold</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {
                        Object.keys(soldByWarehouse)
                            .filter((a) => {
                                return selectedWarehouses.includes(Number.parseInt(a, 10));
                            })
                            .map((key) => {
                                return <Table.Row
                                    key={key}>
                                    <Table.Cell>{warehouses ? warehouses.reduce((a, b) => {
                                        return Number.parseInt(b.id, 10) === Number.parseInt(key, 10) ? b.name : a;
                                    }, "Warehouse not found") : "Warehouse not found"}</Table.Cell>

                                    <Table.Cell>{soldByWarehouseAdjusted[key]}</Table.Cell>
                                    <Table.Cell>{soldByWarehouse[key]}</Table.Cell>
                                </Table.Row>;
                            })
                    }

                </Table.Body>
            </Table>
        );
    }
}


SoldByWarehouse.propTypes = {
    warehouses: PropTypes.array.isRequired,
    soldByWarehouseAdjusted: PropTypes.object.isRequired,
    soldByWarehouse: PropTypes.object.isRequired,
};


export default SoldByWarehouse;



// WEBPACK FOOTER //
// ./src/scenes/Tools/scenes/Procurement/components/DetailTab/components/SoldByWarehouse/index.js